<div
  class="container bg-white p-3"
  [ngClass]="loading ? 'visually-hidden' : ''"
>
  <div class="row" class="row mb-3">
    <div class="col-12 col-sm-2">
      <h6 class="text-primary">Accession Number</h6>
      <p style="font-size: large; font-weight: 500; margin: 0">
        <span style="color: #6992af !important">
          <i
            *ngIf="item.ItemType == 'package'"
            class="fa fa-box-archive"
            pTooltip="Package Properties"
          ></i>
          <i
            *ngIf="item.ItemType == 'legacy'"
            class="fa fa-microscope"
            pTooltip="Legacy Item Properties"
          ></i>
          <i
            *ngIf="item.ItemType === 'doc'"
            class="fa fa-file-lines"
            pTooltip="Document Properties"
          ></i>
        </span>
        {{ item.AccessionNumber }}
      </p>
    </div>
    <div class="col-12 col-sm-9">
      <h6 class="text-primary">Document Title</h6>
      <p style="font-size: large; font-weight: 500; margin: 0">
        {{ item.DocumentTitle }}
      </p>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-11" *ngIf="item.ItemType == 'package'">
      <span class="me-3">
        <p-splitButton
          label="Package Properties"
          icon="fa-regular fa-share-from-square"
          [model]="shareDocPropItems"
          pTooltip="Share Package Properties"
          styleClass="p-button-primary p-button-sm me-2"
          id=""
        ></p-splitButton>
      </span>
      <span class="me-3" *ngIf="item.IsLegacy != 'Yes'">
        <p-splitButton
          label="Package"
          icon="fa-regular fa-share-from-square"
          [model]="shareDocItems"
          pTooltip="Share/Download Package"
          styleClass="p-button-primary p-button-sm me-2"
          id=""
        ></p-splitButton>
      </span>
    </div>
    <div class="col-11" *ngIf="item.ItemType === 'legacy'">
      <span class="me-3">
        <p-splitButton
          label="Legacy Document Properties"
          icon="fa-regular fa-share-from-square"
          [model]="shareDocPropItems"
          pTooltip="Share Legacy Document Properties"
          styleClass="p-button-primary p-button-sm me-2"
          id=""
        ></p-splitButton>
      </span>
    </div>
    <div class="col-11" *ngIf="item.ItemType === 'doc'">
      <span class="me-3">
        <p-splitButton
          label="Document Properties"
          icon="fa-regular fa-share-from-square"
          [model]="shareDocPropItems"
          pTooltip="Share Document Properties"
          styleClass="p-button-primary p-button-sm me-2"
          id=""
        ></p-splitButton>
      </span>
      <span class="me-3">
        <p-splitButton
          label="Document"
          icon="fa-regular fa-share-from-square"
          [model]="shareDocItems"
          pTooltip="Share/Download Document"
          styleClass="p-button-primary p-button-sm me-2"
          id=""
        ></p-splitButton>
      </span>
    </div>
  </div>
  <table>
    <!-- <tr *ngIf="item.PackageNumber && item.PackageNumber.toString()">
      <td class="text-primary">Package Number</td>
      <td>{{ item.PackageNumber }}</td>
    </tr> -->
    <tr *ngIf="item.PackagesFiledIn && item.PackagesFiledIn.toString()">
        <td class="text-primary">Packages Filed In</td>
        <td>{{item.PackagesFiledIn | addSpaceAfterComma}}</td>
    </tr>
     <tr *ngIf="item.ItemType == 'package' && item.DocumentsFiledInPackage">
        <td class="text-primary">Documents Filed In Package</td>
        <td>{{item.DocumentsFiledInPackage | addSpaceAfterComma}}</td>
    </tr>
    <tr *ngIf="item.ItemType == 'legacy'">
      <td class="text-primary">Microform Addresses</td>
      <td>{{ item.MicroformAddresses }}</td>
    </tr>

    <tr *ngIf="item.EstimatedPageCount && item.EstimatedPageCount.toString()">
        <td class="text-primary">Estimated Page Count</td>
        <td>{{item.EstimatedPageCount}}</td>
    </tr>
     <tr *ngIf="item.DocumentSize && item.DocumentSize.toString()">
        <td class="text-primary">Document Size</td>
        <td>{{item.DocumentSize | fileSize }}</td>
    </tr>
    <tr *ngIf="item.DateAddedTimestamp && item.DateAddedTimestamp.toString()">
        <td class="text-primary">Date Added</td>
        <td>{{item.DateAddedTimestamp  | date:'yyyy-MM-dd hh:mm a'}}</td>
    </tr>

    <tr *ngIf="item.AuthorName && item.AuthorName.toString()">
      <td class="text-primary">Author(s)</td>
      <td>{{ item.AuthorName }}</td>
    </tr>
    <tr *ngIf="item.AuthorAffiliation && item.AuthorAffiliation.toString()">
      <td class="text-primary">Author Affiliation</td>
      <td>{{ item.AuthorAffiliation }}</td>
    </tr>
    <tr *ngIf="item.AddresseeName && item.AddresseeName.toString()">
      <td class="text-primary">Addressee Name</td>
      <td>{{ item.AddresseeName }}</td>
    </tr>
    <tr
      *ngIf="item.AddresseeAffiliation && item.AddresseeAffiliation.toString()"
    >
      <td class="text-primary">Addressee Affiliation</td>
      <td>{{ item.AddresseeAffiliation }}</td>
    </tr>
    <tr *ngIf="item.CaseReferenceNumber && item.CaseReferenceNumber.toString()">
      <td class="text-primary">Case Reference Number</td>
      <td>{{ item.CaseReferenceNumber }}</td>
    </tr>
    <tr *ngIf="item.LicenseNumber && item.LicenseNumber.toString()">
      <td class="text-primary">License Number</td>
      <td>{{ item.LicenseNumber }}</td>
    </tr>
    <!-- <tr *ngIf="item.DateAdded && item.DateAdded.toString()">
      <td class="text-primary">Date Added</td>
      <td>{{ item.DateAdded | date }}</td>
    </tr> -->
    <tr *ngIf="item.DocumentDate && item.DocumentDate.toString()">
      <td class="text-primary">Document Date</td>
      <td>{{ item.DocumentDate | date }}</td>
    </tr>
    <tr *ngIf="item.DocumentType && item.DocumentType.toString()">
      <td class="text-primary">Document Type</td>
      <td>{{ item.DocumentType }}</td>
    </tr>
    <tr
      *ngIf="item.DocumentReportNumber && item.DocumentReportNumber.toString()"
    >
      <td class="text-primary">Document Report Number</td>
      <td>{{ item.DocumentReportNumber }}</td>
    </tr>
    <tr *ngIf="item.DocketNumber && item.DocketNumber.toString()">
      <td class="text-primary">Docket Number</td>
      <td>{{ item.DocketNumber }}</td>
    </tr>
    <tr *ngIf="item.DateDocketed">
      <td class="text-primary">Date Docketed</td>
      <td>{{ item.DateDocketed | date }}</td>
    </tr>
    <tr *ngIf="item.Comment && item.Comment.toString()">
      <td class="text-primary">Comment</td>
      <td>{{ item.Comment }}</td>
    </tr>
    <tr *ngIf="item.Keyword && item.Keyword.toString()">
      <td class="text-primary">Keyword</td>
      <td>{{ item.Keyword }}</td>
    </tr>
    <tr *ngIf="item.DistributionListCodes">
      <td class="text-primary">Distribution List Codes</td>
      <td>{{ item.DistributionListCodes }}</td>
    </tr>
    <tr *ngIf="item.ContactPerson && item.ContactPerson.toString()">
      <td class="text-primary">Contact Person</td>
      <td>{{ item.ContactPerson }}</td>
    </tr>
  </table>

  <p-toast position="top-left"></p-toast>
</div>
